export default __webpack_public_path__ + "static/media/logo_transparent_background1.11adc592.png";